import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { sessionStore } from '../stores/SessionStore';
import { academyStore } from '../stores/AcademyStore';
const SessionDialog = observer(() => {
    const [schedule, setSchedule] = useState('');
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (sessionStore.isSessionDialogOpen && sessionStore.selectedTemplate) {
            // Set default schedule to current date/time
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            setSchedule(`${year}-${month}-${day}T${hours}:${minutes}`);
        }
        else {
            setSchedule('');
        }
        setErrors({});
    }, [sessionStore.isSessionDialogOpen, sessionStore.selectedTemplate]);
    const validateForm = () => {
        const newErrors = {};
        if (!schedule.trim()) {
            newErrors.schedule = 'Schedule date/time is required';
        }
        else {
            const scheduleDate = new Date(schedule);
            if (isNaN(scheduleDate.getTime())) {
                newErrors.schedule = 'Invalid date/time format';
            }
            else if (scheduleDate < new Date()) {
                newErrors.schedule = 'Schedule cannot be in the past';
            }
        }
        if (!sessionStore.selectedTemplate) {
            newErrors.template = 'Please select a template';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        if (!sessionStore.selectedTemplate) {
            return;
        }
        try {
            const sessionData = {
                sessionTemplateId: sessionStore.selectedTemplate.id,
                schedule: new Date(schedule).toISOString()
            };
            await sessionStore.createSession(sessionData);
            sessionStore.closeSessionDialog();
            sessionStore.selectedTemplate = null;
            if (academyStore.currentAcademy) {
                sessionStore.fetchSessions(academyStore.currentAcademy.id);
            }
        }
        catch (error) {
            // Error handled by store
        }
    };
    const handleClose = () => {
        sessionStore.closeSessionDialog();
        sessionStore.selectedTemplate = null;
    };
    if (!sessionStore.selectedTemplate) {
        return null;
    }
    return (_jsxs(Modal, { show: sessionStore.isSessionDialogOpen, onHide: handleClose, children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { children: "Schedule Session" }) }), _jsxs(Form, { onSubmit: handleSubmit, children: [_jsxs(Modal.Body, { children: [sessionStore.hasError && (_jsx(Alert, { variant: "danger", className: "mb-3", children: sessionStore.error })), _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Template" }), _jsx(Form.Control, { type: "text", value: sessionStore.selectedTemplate.title, disabled: true })] }), _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Schedule Date/Time *" }), _jsx(Form.Control, { type: "datetime-local", value: schedule, onChange: (e) => {
                                            setSchedule(e.target.value);
                                            if (errors.schedule) {
                                                setErrors(prev => ({ ...prev, schedule: '' }));
                                            }
                                        }, isInvalid: !!errors.schedule, disabled: sessionStore.isLoading }), _jsx(Form.Control.Feedback, { type: "invalid", children: errors.schedule })] })] }), _jsxs(Modal.Footer, { children: [_jsx(Button, { variant: "secondary", onClick: handleClose, disabled: sessionStore.isLoading, className: "btn-touch w-mobile-100", children: "Cancel" }), _jsxs(Button, { variant: "primary", type: "submit", disabled: sessionStore.isLoading, className: "btn-touch w-mobile-100", children: [sessionStore.isLoading && (_jsx(Spinner, { animation: "border", size: "sm", className: "me-2" })), "Schedule Session"] })] })] })] }));
});
export default SessionDialog;
